// Hopzigo logo palette + utility to pick a color from an id/index deterministically.
// Used for avatars, group tiles, member badges to add brand variety.

export const HOPZIGO_PALETTE = [
  { bg: "#1A2A6C", soft: "#E5E9F5", text: "#FFFFFF", name: "navy" },
  { bg: "#26B5A8", soft: "#D4F1ED", text: "#FFFFFF", name: "teal" },
  { bg: "#FF9E1B", soft: "#FFE9C2", text: "#FFFFFF", name: "orange" },
  { bg: "#7C3AED", soft: "#EDE3FF", text: "#FFFFFF", name: "purple" },
  { bg: "#FF4D5E", soft: "#FFE3E3", text: "#FFFFFF", name: "pink" },
];

function hashString(s) {
  let h = 0;
  for (let i = 0; i < (s || "").length; i++) {
    h = (h * 31 + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function pickColor(key) {
  if (typeof key === "number") return HOPZIGO_PALETTE[key % HOPZIGO_PALETTE.length];
  return HOPZIGO_PALETTE[hashString(String(key)) % HOPZIGO_PALETTE.length];
}
